<div class="front-container" [ngClass]="class">
    <div class="front-card">
        <div class="header flex-row">
            <div class="orientation">
                <img appImageSelector alt="mt-image" imageType="icon" [imageKey]="'orientation-' + (front.orientation === 'S' ? 'south' : 'north')">
            </div>
            <div class="ubication">{{front.zoneName}}</div>
            <div class="status">
                <div class="circle" [ngClass]="front.status ? 'active' : 'inactive'"></div>
            </div>
        </div>

        <div class="body flex-col overflow">
            <div class="text">
                <div><strong>{{'drills_depth' | lang | pascalcase}}</strong>: {{front.totalDepth}}mts</div>
                <div><strong>{{'machines_in_front' | lang | pascalcase}}:</strong></div>
            </div>

            <div class="machines flex-row">
                <div class="flex-row col-md-5" *ngFor="let machines of front.machines">
                    <div class="machine-detail" *ngFor="let machine of machines">

                        <ng-template #machineTooltip>
                            <p>
                                {{machine.statusName}} <br>
                                {{machine.machineName}} - {{'shift' | lang: machine.shiftName}} <br>
                                {{'last_activity' | lang | pascalcase}}: {{machine.lastActivity | timePresentation}}hrs <br>
                                {{'time' | lang | pascalcase}}: {{machine.timeDiff}}
                            </p>
                        </ng-template>

                        <div [tooltip]="machineTooltip" content-type="template" placement="right"
                            class="machine-container flex-row">
                            <div class="square" [ngStyle]="{'background-color': machine.color}"></div>

                            <div class="machine-name">
                                {{machine.machineName}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>